import http from './axios';

export interface RuleSetDto {
  id?: number;
  ruleSetCategoryId?: number;
  ruleSetCode?: string;
  ruleSetDescription?: string;
  ruleSetLabel?: string;
  ruleSetName?: string;
  ruleSetSort?: number;
  status?: number;
}

export default class RuleSetServices {
  private readonly list_api = '/v1/ruleset/list';
  private readonly info_api = '/v1/ruleset/info';
  private readonly save_api = '/v1/ruleset/save';
  private readonly update_api = '/v1/ruleset/update';
  private readonly remove_api = '/v1/ruleset/delete';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: RuleSetDto) {
    const params = { ...data, ruleSetSort: '1', ruleSetCode: 'RULE_SET_' + data.ruleSetCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: RuleSetDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }
}
